import { defineComponent as _defineComponent } from 'vue'
import AppRouter from '@/router';
import {Routes} from '@/router/Routes';
import {useModalInstance} from '@/composables/useModalInstance';


export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveReportModal',
  setup(__props) {

const modal = useModalInstance<{}, true>();

const goToSearchForDeal = () => {
  AppRouter.push({
    name: Routes.DEALS.DEALS_LIST,
  });
  modal.closeModal();
}

return { __sfc: true,modal, goToSearchForDeal }
}

})